export default __webpack_public_path__ + "static/media/mojaco_sorry.577f13ad.png";